import { jump, getDataThrowToMicroapp } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import type { DataType } from '@/pages/activity-manage/merchants/venue-detail/constants/index';

const baseLink = '/activity-manage/myCreate/daily-activities-operation';

const data = getDataThrowToMicroapp({ baseLink });

const _data: DataType = {
  ...data,
  sence: 'daily',
  // 收品池列表
  jumpCollection(query, type) {
    jump(baseLink + '/pitEnroll/roomlist' + query, type);
  },
  // 收品池列表
  jumpPoolList(query, type) {
    jump(baseLink + '/pitEnroll/roomlist' + query, type);
  },
  jumpEffectData(query, type) {
    jump(baseLink + '/pitEnroll/effectdata' + query, type);
  },
  // // 点击换品跳转换品页
  // jumpSignup(query, type) {
  //   jump(baseLink + '/signup' + query, type);
  // },
};

export default _data;
